import { gsap, Power4 } from "gsap/all"
// import isMobile from 'lib/device-check';
import PropTypes from "prop-types"
import React, { useEffect, useLayoutEffect, useRef } from "react"
// import BraceletInstructions from '../BraceletInstructions/BraceletInstructions';

function BraceletShadow(props) {
  const shadowRef = useRef()
  const { opacity, zIndex, to } = props

  useEffect(() => {
    animate()
  }, [opacity])

  const animate = () => {
    const { duration } = props
    gsap.fromTo(
      shadowRef.current,
      { opacity: 0.1 },
      {
        opacity,
        x: "-50%",
        y: to + "%",
        ease: Power4.easeOut,
        duration,
      }
    )
  }

  const zIndexStyle = {
    zIndex,
  }
  return (
    <React.Fragment>
      <div className="shadow" style={zIndexStyle} ref={shadowRef} />
    </React.Fragment>
  )
}

BraceletShadow.propTypes = {
  duration: PropTypes.number.isRequired,
  opacity: PropTypes.number.isRequired,
  zIndex: PropTypes.number.isRequired,
  // scale: PropTypes.number.isRequired,
  to: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default BraceletShadow
